module.exports = __webpack_public_path__ + "img/CrossChainBridge_icon3.272cd5bb.svg";